<template>
  <v-multiselect
   label="nom"
   track-by="id_ref_commune"
   :options="communes"
   :value="realValue"
   :internal-search="false"
   :loading="isLoading"
   :close-on-select="true"
   :name="name"
   :show-labels="false"
   @search-change="doSearch"
   @select="setCommune"
   :disabled="$can.not('edit-exploitation')"
  >
    <template slot="option" slot-scope="{option}">
      {{ option.code_postal }} - {{ option.nom }}
    </template>
    <template slot="singleLabel" slot-scope="{option}">
      {{ option.code_postal }} - {{ option.nom }}
    </template>
  </v-multiselect>
</template>

<script>

import { searchCommune } from '@/api/client-api'
import debounce from 'lodash/debounce'

export default {
  name: 'SelectCommune',

  inheritAttrs: false,

  props: {
    value: Number,
    initialCommune: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: 'notDefined'
    }
  },

  data () {
    return {
      communes: this.initialCommune,
      isLoading: false
    }
  },

  computed: {
    realValue () {
      let realValue = this.communes.find(o => o.id_ref_commune === this.value)
      return realValue
    }
  },

  methods: {
    searchCommune: function (search, loading) {
      if (search.length < 0) {
        return
      }
      loading(true)
      searchCommune(search).then((result) => {
        this.communes = result
        loading(false)
      })
    },
    setCommune (commune) {
      this.$emit('input', commune.id_ref_commune)
    },

    doSearch: debounce(function (query) {
      if (query.length <= 3) {
        return
      }
      this.isLoading = true
      searchCommune(query).then((result) => {
        this.communes = result
        this.isLoading = false
      })
    }, 200)
  }
}
</script>
